export default __webpack_public_path__ + "static/media/amertrad1.d3ed5744.png";